<script>
import DonationModal from "@/commons/DonationModal/CampaignDonationModal.vue";
import $ from 'jquery';

export default {
    name: "CampaignPublicViewPayment",
    components: {DonationModal},
    data() {
        return {
            isShowDonationModal: true,
        };
    },
    methods: {
        dismissDonationModal() {
            window.parent.postMessage({
                action: 'dismiss',
            }, '*');
        },
    },
    mounted() {
        $('body').css('background-color', 'transparent')
    }
}
</script>

<template>
    <div>
        <DonationModal
            v-if="isShowDonationModal"
            @close="isShowDonationModal = false"
            @clickOutsideBody="dismissDonationModal"
        />
    </div>
</template>

<style scoped lang="scss">

</style>
